<!-- 新建检查计划页面 -->
<template>
  <div class="create-check-plan">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <el-button
          type="text"
          icon="el-icon-arrow-left"
          @click="goBack"
          class="back-btn"
        >
          新建安全检查计划
        </el-button>
      </div>
    </div>

    <!-- 表单内容 -->
    <div class="form-container">
      <el-form
        ref="checkPlanForm"
        :model="form"
        :rules="rules"
        label-width="120px"
        class="check-plan-form"
      >
        <!-- 计划核心信息卡片 -->
        <div class="form-card">
          <div class="card-header">
            <span class="card-title">计划核心信息</span>
          </div>
          <div class="card-content">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="计划名称" prop="planName" required>
                  <el-input
                    v-model="form.planName"
                    placeholder="请输入计划名称,如:2024年Q1消防专项检查"
                    maxlength="100"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="检查类型" prop="checkType" required>
                  <el-select
                    v-model="form.checkType"
                    placeholder="请选择检查类型"
                    style="width: 100%"
                    @change="handleCheckTypeChange"
                  >
                    <el-option
                      v-for="item in checkTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="责任部门"
                  prop="responsibleDeptId"
                  required
                >
                  <el-cascader
                    v-model="form.responsibleDeptId"
                    :options="departmentTreeData"
                    :props="deptTreeProps"
                    placeholder="请选择责任部门"
                    style="width: 100%"
                    clearable
                    :show-all-levels="false"
                    @change="handleDepartmentChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="负责人"
                  prop="responsiblePersonId"
                  required
                >
                  <el-select
                    v-model="form.responsiblePersonId"
                    placeholder="请选择负责人"
                    style="width: 100%"
                    multiple
                    collapse-tags
                    @change="handlePersonChange"
                    @click="showPersonDialog = true"
                  >
                    <el-option
                      v-for="item in personOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="计划描述">
                  <el-input
                    v-model="form.remark"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入计划描述..."
                    maxlength="500"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 时间与周期设置部分 -->
            <div class="section-divider"></div>
            <div class="section-title">时间与周期设置</div>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="计划周期" prop="planCycle" required>
                  <el-radio-group
                    v-model="form.planCycle"
                    @change="handlePlanCycleChange"
                  >
                    <el-radio :label="0">一次性计划</el-radio>
                    <el-radio :label="1">周期性计划</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="开始日期" prop="startDate" required>
                  <el-date-picker
                    v-model="form.startDate"
                    type="date"
                    placeholder="选择开始日期"
                    style="width: 100%"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    @change="handleStartDateChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结束日期" prop="endDate">
                  <el-date-picker
                    v-model="form.endDate"
                    type="date"
                    placeholder="选择结束日期"
                    style="width: 100%"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :disabled="!form.startDate"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="form.planCycle === 1">
              <el-col :span="12">
                <el-form-item label="执行频率" prop="checkFrequency" required>
                  <el-select
                    v-model="form.checkFrequency"
                    placeholder="请选择执行频率"
                    style="width: 100%"
                    @change="handleCheckFrequencyChange"
                  >
                    <el-option
                      v-for="item in checkFrequencyOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="频率详情" prop="executionDetail" required>
                  <el-select
                    v-model="form.executionDetail"
                    placeholder="请选择频率详情"
                    style="width: 100%"
                    :disabled="
                      form.checkFrequency === null ||
                      form.checkFrequency === undefined
                    "
                    :multiple="
                      form.checkFrequency === 1 || form.checkFrequency === 2
                    "
                    :collapse-tags="
                      form.checkFrequency === 1 || form.checkFrequency === 2
                    "
                  >
                    <el-option
                      v-for="item in frequencyDetailOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 检查范围与标准部分 -->
            <div class="section-divider"></div>
            <div class="section-title">检查范围与标准</div>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="检查区域" prop="list" required>
                  <el-select
                    v-model="form.list"
                    placeholder="请选择检查区域"
                    style="width: 100%"
                    multiple
                    collapse-tags
                    @click="showAreaDialog = true"
                  >
                    <el-option
                      v-for="item in areaOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="关联检查表" prop="checkListId" required>
                  <el-select
                    v-model="form.checkListId"
                    placeholder="请选择检查表"
                    style="width: 100%"
                    :disabled="!form.checkType && form.checkType !== 0"
                    :loading="formOptionsLoading"
                    @change="handleCheckListChange"
                  >
                    <el-option
                      v-for="item in formOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-button
                    type="text"
                    icon="el-icon-view"
                    @click="previewInspectionItems"
                  >
                    预览检查项内容
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="form-actions">
          <el-button @click="handleReset" class="reset-btn">重置</el-button>
          <el-button
            type="primary"
            @click="handleSubmit"
            :loading="submitting"
            class="create-btn"
          >
            立即创建
          </el-button>
        </div>
      </el-form>
    </div>

    <!-- 负责人选择对话框 -->
    <el-dialog
      title="选择负责人"
      :visible.sync="showPersonDialog"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="person-selection">
        <el-input
          v-model="personSearchKeyword"
          placeholder="搜索负责人"
          style="margin-bottom: 15px"
        />
        <el-table
          :data="filteredPersonOptions"
          @selection-change="handlePersonSelection"
          max-height="300"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column prop="name" label="姓名" />
          <el-table-column prop="department" label="部门" />
          <el-table-column prop="position" label="职位" />
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showPersonDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmPersonSelection"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 检查区域选择对话框 -->
    <el-dialog
      title="选择检查区域"
      :visible.sync="showAreaDialog"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="area-selection">
        <el-input
          v-model="areaSearchKeyword"
          placeholder="搜索区域"
          style="margin-bottom: 15px"
        />
        <el-tree
          :data="areaTreeData"
          :props="treeProps"
          show-checkbox
          node-key="id"
          :default-checked-keys="checkedAreas"
          @check="handleAreaCheck"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAreaDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmAreaSelection">确定</el-button>
      </div>
    </el-dialog>

    <!-- 检查项预览对话框 -->
    <el-dialog
      title="检查项内容预览"
      :visible.sync="showPreviewDialog"
      width="800px"
      :close-on-click-modal="true"
      :modal="true"
      :append-to-body="true"
      :z-index="3000"
    >
      <div class="inspection-preview">
        <el-table :data="previewData" max-height="400">
          <el-table-column prop="itemName" label="检查项目" />
          <el-table-column prop="checkListStandard" label="检查标准" />
          <el-table-column prop="isRequired" label="是否是必检项" width="100" />
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showPreviewDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addCheckPlan,
  getUserList,
  getDeptTree,
  getCheckListByType,
  getCheckListPreview,
} from "./api";

export default {
  name: "CreateCheckPlan",
  data() {
    return {
      // 表单数据 - 根据实体类字段调整
      form: {
        planName: "", // 计划名称
        checkType: null, // 检查类型（1-8）
        responsibleDeptId: null, // 责任部门ID
        responsibleDeptName: "", // 责任部门名称
        responsiblePersonId: [], // 负责人ID数组
        responsiblePersonName: "", // 负责人姓名
        checkFrequency: null, // 执行频率（0-2）
        planCycle: null, // 计划周期（0-1）
        executionDetail: [], // 频率详情（当每周/每月为多选）
        checkListId: null, // 关联检查表ID
        checkListName: "", // 关联检查表名称
        remark: "", // 计划描述
        list: [], // 检查区域列表
      },

      // 表单验证规则 - 根据实体类字段调整
      rules: {
        planName: [
          { required: true, message: "请输入计划名称", trigger: "blur" },
          {
            min: 2,
            max: 100,
            message: "计划名称长度在2到100个字符",
            trigger: "blur",
          },
        ],
        checkType: [
          { required: true, message: "请选择检查类型", trigger: "change" },
        ],
        responsibleDeptId: [
          { required: true, message: "请选择责任部门", trigger: "change" },
        ],
        responsiblePersonId: [
          { required: true, message: "请选择负责人", trigger: "change" },
        ],
        checkFrequency: [
          { required: true, message: "请选择执行频率", trigger: "change" },
        ],
        planCycle: [
          { required: true, message: "请选择计划周期", trigger: "change" },
        ],
        list: [
          { required: true, message: "请选择检查区域", trigger: "change" },
        ],
        checkListId: [
          { required: true, message: "请选择检查表", trigger: "change" },
        ],
      },

      // 检查类型选项 - 根据实体类枚举值调整
      checkTypeOptions: [
        { label: "消防安全", value: 1 },
        { label: "电气安全", value: 2 },
        { label: "设备安全", value: 3 },
        { label: "化学品安全", value: 4 },
        { label: "职业健康", value: 5 },
        { label: "环境保护", value: 6 },
        { label: "安全管理", value: 7 },
        { label: "其他", value: 8 },
      ],

      // 执行频率选项
      checkFrequencyOptions: [
        { label: "每日", value: 0 },
        { label: "每周", value: 1 },
        { label: "每月", value: 2 },
      ],

      // 计划周期选项
      planCycleOptions: [
        { label: "一次性", value: 0 },
        { label: "周期性", value: 1 },
      ],

      // 部门树形数据
      departmentTreeData: [],

      // 级联选择器配置
      deptTreeProps: {
        children: "children",
        label: "deptName",
        value: "id",
        emitPath: false, // 只返回最后一级的值
      },

      // 负责人选项
      personOptions: [],
      personSearchKeyword: "",
      personTableData: [],
      // 区域选项
      areaOptions: [],
      areaTreeData: [
        {
          id: 1,
          label: "生产区域",
          children: [
            { id: 11, label: "生产车间A区" },
            { id: 12, label: "生产车间B区" },
            { id: 13, label: "生产车间C区" },
          ],
        },
        {
          id: 2,
          label: "仓储区域",
          children: [
            { id: 21, label: "仓储库房A区" },
            { id: 22, label: "仓储库房B区" },
            { id: 23, label: "仓储库房C区" },
          ],
        },
        {
          id: 3,
          label: "办公区域",
          children: [
            { id: 31, label: "办公楼一层" },
            { id: 32, label: "办公楼二层" },
            { id: 33, label: "办公楼三层" },
          ],
        },
      ],

      // 检查表选项（根据检查类型动态获取）
      formOptions: [],
      formOptionsLoading: false,

      // 频率详情选项
      frequencyDetailOptions: [],

      // 对话框状态
      showPersonDialog: false,
      showAreaDialog: false,
      showPreviewDialog: false,

      // 树形组件配置
      treeProps: {
        children: "children",
        label: "label",
      },

      // 选中的项目
      checkedAreas: [],
      selectedPersons: [],

      // 搜索关键词
      areaSearchKeyword: "",

      // 预览数据
      previewData: [],

      // 提交状态
      submitting: false,
    };
  },

  computed: {
    // 过滤后的负责人选项
    filteredPersonOptions() {
      if (!this.personSearchKeyword) {
        return this.personTableData;
      }
      return this.personTableData.filter(
        (item) =>
          item.name.includes(this.personSearchKeyword) ||
          item.department.includes(this.personSearchKeyword) ||
          item.position.includes(this.personSearchKeyword)
      );
    },
  },

  mounted() {
    this.initData();
  },

  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },

    // 初始化数据
    async initData() {
      // 初始化区域选项
      this.areaOptions = this.areaTreeData.map((area) => ({
        label: area.label,
        value: area.id,
      }));

      // 从接口获取部门树形数据
      await this.loadDeptTree();

      // 从接口获取用户列表
      await this.loadUserList();
    },

    // 加载部门树形数据
    async loadDeptTree() {
      try {
        const response = await getDeptTree();
        console.log("部门树形数据响应:", response);
        if (response && response.data) {
          this.departmentTreeData = response.data.data;
          console.log("部门树形数据已设置:", this.departmentTreeData);
        } else {
          console.warn("部门树形数据为空");
        }
      } catch (error) {
        console.error("获取部门树形数据失败:", error);
        this.$message.error("获取部门树形数据失败");
      }
    },

    // 加载用户列表
    async loadUserList() {
      try {
        const response = await getUserList();
        if (response && response.data && response.data.length > 0) {
          // 更新负责人表格数据
          this.personTableData = response.data.map((user) => ({
            id: user.id,
            name: user.name,
            department: user.deptName || user.department || "未知部门",
            position: user.postName || user.position || "未知职位",
          }));

          // 更新负责人选项
          this.personOptions = this.personTableData.map((person) => ({
            label: person.name,
            value: person.id,
          }));
        }
      } catch (error) {
        console.error("获取用户列表失败:", error);
        this.$message.error("获取用户列表失败");
        // 如果接口失败，使用默认数据
        this.personOptions = this.personTableData.map((person) => ({
          label: person.name,
          value: person.id,
        }));
      }
    },

    // 检查类型变化处理（动态获取检查表）
    async handleCheckTypeChange(value) {
      console.log("检查类型变化:", value);
      // 清空已选检查表
      this.form.checkListId = null;
      this.form.checkListName = "";
      // 未选择检查类型，清空选项
      if (!value && value !== 0) {
        this.formOptions = [];
        return;
      }
      try {
        this.formOptionsLoading = true;
        const res = await getCheckListByType(value);
        const list = (res && res.data && (res.data.data || res.data)) || [];
        this.formOptions = Array.isArray(list)
          ? list.map((item) => ({
              label: item.name || item.checkListName || item.label,
              value: item.id || item.checkListId || item.value,
            }))
          : [];
      } catch (e) {
        console.error("获取检查表失败:", e);
        this.formOptions = [];
      } finally {
        this.formOptionsLoading = false;
      }
    },

    // 开始日期变化处理
    handleStartDateChange(value) {
      console.log("开始日期变化:", value);
      // 如果开始日期被清空，同时清空结束日期
      if (!value) {
        this.form.endDate = "";
      }
    },

    // 计划周期变化处理
    handlePlanCycleChange(value) {
      console.log("计划周期变化:", value);
      if (value === 0) {
        // 一次性计划时，清空频率相关字段，但不清空结束日期
        this.form.checkFrequency = null;
        this.form.executionDetail = [];
      }
    },

    // 执行频率变化处理
    handleCheckFrequencyChange(value) {
      console.log("执行频率变化:", value);
      this.form.executionDetail = [];
      this.form.executionDetail = value === 0 ? "" : [];
      // 根据频率设置详情选项
      const frequencyDetailMap = {
        0: [{ label: "每日", value: "daily" }], // 每日（单选）
        1: [
          // 每周（多选）
          { label: "周一", value: "1" },
          { label: "周二", value: "2" },
          { label: "周三", value: "3" },
          { label: "周四", value: "4" },
          { label: "周五", value: "5" },
          { label: "周六", value: "6" },
          { label: "周日", value: "7" },
        ],
        2: Array.from({ length: 31 }, (_, i) => ({
          label: `${i + 1}日`,
          value: String(i + 1),
        })), // 每月（多选 1-31）
      };

      this.frequencyDetailOptions = frequencyDetailMap[value] || [];
      console.log("执行频率:", this.frequencyDetailOptions.length);
      this.$nextTick(() => {
        this.$refs.checkPlanForm &&
          this.$refs.checkPlanForm.validateField("executionDetail");
      });
    },

    // 负责人选择处理
    handlePersonSelection(selection) {
      this.selectedPersons = selection;
    },

    // 确认负责人选择
    confirmPersonSelection() {
      if (this.selectedPersons.length > 0) {
        this.form.responsiblePersonId = this.selectedPersons.map(
          (person) => person.id
        );
        this.form.responsiblePersonName = this.selectedPersons
          .map((person) => person.name)
          .join(",");
      } else {
        this.form.responsiblePersonId = [];
        this.form.responsiblePersonName = "";
      }
      this.showPersonDialog = false;
    },

    // 部门变化处理
    handleDepartmentChange(value) {
      console.log("部门选择变化:", value);

      // 从树形数据中查找选中的部门
      const findDeptName = (nodes, targetId) => {
        for (const node of nodes) {
          if (node.id === targetId) {
            return node.deptName;
          }
          if (node.children && node.children.length > 0) {
            const found = findDeptName(node.children, targetId);
            if (found) return found;
          }
        }
        return null;
      };

      if (value) {
        const deptName = findDeptName(this.departmentTreeData, value);
        if (deptName) {
          this.form.responsibleDeptName = deptName;
          console.log("选中的部门名称:", deptName);
        }
      } else {
        this.form.responsibleDeptName = "";
      }
    },

    // 负责人变化处理
    handlePersonChange(value) {
      // 处理多选负责人
      if (Array.isArray(value) && value.length > 0) {
        const selectedPersons = this.personTableData.filter((person) =>
          value.includes(person.id)
        );
        this.form.responsiblePersonName = selectedPersons
          .map((person) => person.name)
          .join(",");
      } else {
        this.form.responsiblePersonName = "";
      }
    },

    // 检查表变化处理
    handleCheckListChange(value) {
      const selectedForm = this.formOptions.find(
        (form) => form.value === value
      );
      if (selectedForm) {
        this.form.checkListName = selectedForm.label;
      }
    },

    // 区域选择处理
    handleAreaCheck(data, checked) {
      console.log("区域选择:", data, checked);
    },

    // 确认区域选择
    confirmAreaSelection() {
      this.showAreaDialog = false;
      // 这里可以处理选中的区域
    },

    // 预览检查项（从接口获取）
    async previewInspectionItems() {
      const checkListId = this.form.checkListId;
      if (!checkListId) {
        this.$message.warning("请先选择检查表");
        return;
      }
      try {
        const res = await getCheckListPreview(checkListId);
        const rows = (res && res.data && (res.data.data || res.data)) || [];
        // 兼容字段名：category/item/standard/method 若后端字段不同可在此适配
        this.previewData = rows.map((item) => ({
          // category: item.category || item.typeName || item.groupName || "",
          itemName: item.itemName || "",
          checkListStandard: item.checkListStandard || "",
          isRequired: item.isRequired === 0 ? "否" : "是" || "",
        }));
        this.showPreviewDialog = true;
      } catch (e) {
        console.error("获取检查项预览失败:", e);
        this.$message.error("获取检查项预览失败");
      }
    },

    // 重置表单
    handleReset() {
      this.$refs.checkPlanForm.resetFields();
      this.form = {
        planName: "",
        checkType: null,
        responsibleDeptId: null,
        responsibleDeptName: "",
        responsiblePersonId: [],
        responsiblePersonName: "",
        checkFrequency: null,
        planCycle: null,
        executionDetail: [],
        checkListId: null,
        checkListName: "",
        remark: "",
        list: [],
      };
    },

    // 提交表单
    async handleSubmit() {
      try {
        await this.$refs.checkPlanForm.validate();
        this.submitting = true;

        // 构建提交数据 - 根据实体类字段调整
        const areaList = (this.form.list || []).map((areaId) => {
          const opt =
            (this.areaOptions || []).find((o) => o.value === areaId) || {};
          return { areaName: opt.label || String(areaId), areaId };
        });
        // 提取areaName和areaId，用逗号分隔
        const typeName = areaList.map((item) => item.areaName).join(",");
        const typeCode = areaList.map((item) => item.areaId).join(",");

        const submitData = {
          ...this.form,
          // 检查区域数据封装为对象数组
          list: areaList,
          // 添加typeName和typeCode字段
          typeName: typeName,
          typeCode: typeCode,
          // 处理多选负责人数据
          responsiblePersonId: Array.isArray(this.form.responsiblePersonId)
            ? this.form.responsiblePersonId.join(",")
            : this.form.responsiblePersonId,
        };

        console.log("提交数据:", submitData);

        // 调用API
        const response = await addCheckPlan(submitData);

        if (response && (response.code === 200 || response.success !== false)) {
          this.$message.success("检查计划创建成功");
          this.goBack()
          // this.$router.push(
          //   "/dispatched-personnel-track/check-inspection-plan-list/index"
          // );
        } else {
          this.$message.error(response.message || "创建失败");
        }
      } catch (error) {
        console.error("创建失败:", error);
        this.$message.error("创建失败: " + (error.message || "网络错误"));
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.create-check-plan {
  padding: 12px;
  background-color: #f5f7fa;
  min-height: 100vh;
  padding-bottom: 100px; /* 增加底部内边距，避免被导航栏遮挡 */

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .header-left {
      .back-btn {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        padding: 0;

        &:hover {
          color: #409eff;
        }
      }
    }

    .header-right {
      .el-breadcrumb {
        font-size: 14px;
        color: #909399;
      }
    }
  }

  .form-container {
    .form-card {
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      margin-bottom: 10px;
      overflow: hidden;

      .card-header {
        background: #f8f9fa;
        padding: 8px 12px;
        border-bottom: 1px solid #ebeef5;

        .card-title {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
        }
      }

      .card-content {
        padding: 12px;
      }

      // 分区样式
      .section-divider {
        height: 1px;
        background: #ebeef5;
        margin: 20px 0;
      }

      .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 16px;
        padding-left: 8px;
        border-left: 4px solid #409eff;
      }
    }

    .form-actions {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 12px;
      padding: 10px 0 10px 0; /* 增加底部内边距 */
      position: relative;
      z-index: 10; /* 确保按钮在最上层 */

      .reset-btn {
        background: #f5f7fa;
        border: 1px solid #dcdfe6;
        color: #606266;
        padding: 10px 20px;
        min-width: 80px; /* 确保按钮有最小宽度 */

        &:hover {
          background: #ecf5ff;
          border-color: #b3d8ff;
          color: #409eff;
        }
      }

      .create-btn {
        background: #409eff;
        border-color: #409eff;
        padding: 10px 20px;
        min-width: 100px; /* 确保按钮有最小宽度 */

        &:hover {
          background: #66b1ff;
          border-color: #66b1ff;
        }
      }
    }
  }

  .department-tree,
  .area-selection {
    max-height: 300px;
    overflow-y: auto;
  }

  .person-selection {
    .el-table {
      border: 1px solid #ebeef5;
    }
  }

  .inspection-preview {
    .el-table {
      border: 1px solid #ebeef5;
    }
  }
}

// 表单样式优化
::v-deep .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  border-radius: 4px;
  border: 1px solid #dcdfe6;

  &:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-radio-group {
  .el-radio {
    margin-right: 30px;
  }
}

::v-deep .el-date-editor {
  width: 100%;
}

// 必填字段标识
::v-deep .el-form-item.is-required .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

// 确保页面有足够的滚动空间
body {
  overflow-x: hidden;
  overflow-y: auto;
}

// 确保按钮区域不被遮挡
.form-actions {
  margin-bottom: 10px !important; /* 强制底部间距 */
}

// 预览弹窗样式修复
::v-deep .el-dialog__wrapper {
  z-index: 3000 !important;
}

::v-deep .el-dialog {
  z-index: 3001 !important;
}

::v-deep .el-dialog__header {
  z-index: 3002 !important;
}

::v-deep .el-dialog__body {
  z-index: 3002 !important;
}

::v-deep .el-dialog__footer {
  z-index: 3002 !important;
}

// 表单样式优化
::v-deep .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  border-radius: 4px;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-radio-group {
  .el-radio {
    margin-right: 30px;
  }
}

// 对话框样式
::v-deep .el-dialog {
  border-radius: 8px;
}

::v-deep .el-dialog__header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #ebeef5;
  border-radius: 8px 8px 0 0;
}

::v-deep .el-dialog__body {
  padding: 20px;
}

::v-deep .el-dialog__footer {
  background-color: #f8f9fa;
  border-top: 1px solid #ebeef5;
  border-radius: 0 0 8px 8px;
}
</style>
